import { FC, RefObject } from "react";
import { useSelector } from "react-redux";
import { appointment, views } from "../../../../types/calendar";
import { getWeekDays } from "../../../../utils/DateUtils";

interface CalendarNavProps {
  containerNav: RefObject<HTMLDivElement>;
  appointments: appointment[];
}

const CalendarNav: FC<CalendarNavProps> = ({ containerNav, appointments }) => {
  const { date, currentLang } = useSelector(
    (state: {
      calendar: { date: Date; view: views; appointments: appointment[] };
      user: {
        currentLang: "en" | "ar";
      };
    }) => {
      return {
        date: new Date(state.calendar.date),
        view: state.calendar.view,
        currentLang: state.user.currentLang,
      };
    }
  );

  const weekDays =
    currentLang === "ar"
      ? [
          "السبت",
          "الأحد",
          "الإثنين",
          "الثلاثاء",
          "الاربعاء",
          "الخميس",
          "الجمعه",
        ]
      : [
          "Saturday",
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
        ];

  return (
    <div
      ref={containerNav}
      className="sticky top-0 z-30 flex-none bg-white  sm:pr-8"
    >
      <div className="-mr-px hidden grid-cols-7 divide-x divide-gray-100 border-r border-gray-100 text-sm leading-6 text-gray-500 sm:grid">
        <div className="col-end-1 w-14" />
        {getWeekDays(date, currentLang).map((day, index) => (
          <div key={index} className="flex items-center justify-center py-3  ">
            <span className="flex items-baseline gap-1 ">
              {/* {day?.day} */}
              {weekDays[index]}
              {
                // function to check if this day has an  appointments or no !!
                new Date().toLocaleDateString() ===
                new Date(day.dayDate).toLocaleDateString() ? (
                  <span className="mt-1 flex h-8 w-8 items-center justify-center rounded-full bg-color-primary font-semibold text-white">
                    {day.dayDate.split("-")[2]}
                  </span>
                ) : (
                  <span className="items-center justify-center  font-semibold text-gray-900">
                    {day.dayDate.split("-")[2]}
                  </span>
                )
              }
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarNav;
